<aside class="sidebar" [class.collapsed]="collapsed">
  <div class="sidebar-head">
    <div class="project-block">
      <h2 class="project-title">{{ projectName }}</h2>
      <button
        type="button"
        class="back-btn"
        aria-label="Recolher/Expandir"
        (click)="toggleCollapsed()"
      >
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <path
            *ngIf="!collapsed"
            d="M15 18l-6-6 6-6"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
          />
          <path
            *ngIf="collapsed"
            d="M9 6l6 6-6 6"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
          />
        </svg>
      </button>
    </div>
  </div>

  <nav class="menu" aria-label="Menu lateral">
    <div class="section">
      <div class="section-title">Monitoramento</div>
      <a
        class="item"
        routerLink="/monitoramento"
        routerLinkActive="active"
        [routerLinkActiveOptions]="{ exact: true }"
        title="Painel principal"
      >
        <span class="item-icon" aria-hidden="true">
          <svg viewBox="0 0 24 24">
            <path d="M4 6h16v12H4z" fill="none" stroke="currentColor" stroke-width="2" />
            <path
              d="M8 16h8"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
            />
          </svg>
        </span>
        <span class="item-text">Painel principal</span>
      </a>

      <a
        class="item"
        routerLink="/monitoramento/area-trabalho"
        routerLinkActive="active"
        title="Painel Área de descanso"
      >
        <span class="item-icon" aria-hidden="true">
          <svg viewBox="0 0 24 24">
            <path
              d="M12 2v6"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
            />
            <path
              d="M8 6h8"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
            />
            <path
              d="M12 8a6 6 0 1 0 6 6"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
            />
          </svg>
        </span>
        <span class="item-text">Painel Área de descanso</span>
      </a>

      <a
        class="item"
        routerLink="/monitoramento/area-descanso"
        routerLinkActive="active"
        title="Painel Área produtiva"
      >
        <span class="item-icon" aria-hidden="true">
          <svg viewBox="0 0 24 24">
            <path
              d="M12 3a8.5 8.5 0 1 0 8.5 8.5"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
            />
            <path
              d="M12 7v5l3 2"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
            />
          </svg>
        </span>
        <span class="item-text">Painel Área produtiva</span>
      </a>

      <a
        class="item"
        routerLink="/monitoramento/alertas"
        routerLinkActive="active"
        title="Alertas"
        *ngIf="!isUser"
      >
        <span class="item-icon" aria-hidden="true">
          <svg viewBox="0 0 24 24">
            <path
              d="M12 3 2.5 19h19L12 3z"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linejoin="round"
            />
            <path d="M12 9v4" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
            <circle cx="12" cy="17" r="1" fill="currentColor" />
          </svg>
        </span>
        <span class="item-text">Alertas</span>
      </a>
    </div>

    <div class="section" *ngIf="!isUser">
      <div class="section-title">Relatório</div>
      <a class="item" routerLink="/relatorio" routerLinkActive="active" title="Gerar relatório">
        <span class="item-icon" aria-hidden="true">
          <svg viewBox="0 0 24 24">
            <path
              d="M7 3h8l3 3v15H7z"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linejoin="round"
            />
            <path
              d="M15 3v4h4"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linejoin="round"
            />
            <path
              d="M9 11h7M9 15h7"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
            />
          </svg>
        </span>
        <span class="item-text">Gerar relatório</span>
      </a>
    </div>

    <div class="section" *ngIf="!isUser">
      <div class="section-title">Gerenciamento</div>
      <a
        class="item"
        routerLink="/gerenciamento/colaboradores"
        routerLinkActive="active"
        title="Colaboradores"
      >
        <span class="item-icon" aria-hidden="true">
          <svg viewBox="0 0 24 24">
            <path
              d="M8 9a3 3 0 1 0 0-6 3 3 0 0 0 0 6z"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
            />
            <path
              d="M2.8 20c1-3.1 3.1-4.6 5.2-4.6S12.2 16.9 13.2 20"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
            />
            <path
              d="M16 10h6M16 14h6M16 18h6"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
            />
          </svg>
        </span>
        <span class="item-text">Colaboradores</span>
      </a>

      <a
        class="item"
        routerLink="/gerenciamento/zonas-gateways"
        routerLinkActive="active"
        title="Áreas & Gateways"
      >
        <span class="item-icon" aria-hidden="true">
          <svg viewBox="0 0 24 24">
            <path
              d="M12 22s7-4.4 7-11a7 7 0 0 0-14 0c0 6.6 7 11 7 11z"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linejoin="round"
            />
            <circle cx="12" cy="11" r="2.5" fill="none" stroke="currentColor" stroke-width="2" />
          </svg>
        </span>
        <span class="item-text">Áreas &amp; Gateways</span>
      </a>

      <a
        class="item"
        routerLink="/gerenciamento/campos-customizados"
        routerLinkActive="active"
        title="Campos customizados"
      >
        <span class="item-icon" aria-hidden="true">
          <svg viewBox="0 0 24 24">
            <path
              d="M4 7h16M4 12h10M4 17h13"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
            />
          </svg>
        </span>
        <span class="item-text">Campos customizados</span>
      </a>

      <a
        *ngIf="canManageUsers"
        class="item"
        routerLink="/gerenciamento/usuarios"
        routerLinkActive="active"
        title="Usuários"
      >
        <span class="item-icon" aria-hidden="true">
          <svg viewBox="0 0 24 24">
            <path
              d="M12 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8z"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
            />
            <path
              d="M4 21c1.8-3.6 4.8-5 8-5s6.2 1.4 8 5"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
            />
          </svg>
        </span>
        <span class="item-text">Usuários</span>
      </a>

      <a
        class="item"
        routerLink="/gerenciamento/regras-projeto"
        routerLinkActive="active"
        title="Regras do projeto"
      >
        <span class="item-icon" aria-hidden="true">
          <svg viewBox="0 0 24 24">
            <path
              d="M4 7h16M7 7v10M17 7v10M4 17h16"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
            />
            <circle cx="7" cy="11" r="2" fill="none" stroke="currentColor" stroke-width="2" />
            <circle cx="17" cy="13" r="2" fill="none" stroke="currentColor" stroke-width="2" />
          </svg>
        </span>
        <span class="item-text">Regras do projeto</span>
      </a>
    </div>

    <div class="section" *ngIf="isAdmin()">
      <div class="section-title">Suporte</div>
      <a class="item" routerLink="/suporte" routerLinkActive="active" title="Painel de suporte">
        <span class="item-icon" aria-hidden="true">
          <svg viewBox="0 0 24 24">
            <path
              d="M4 12a8 8 0 0 1 16 0v4a3 3 0 0 1-3 3h-1"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
            />
            <path
              d="M4 12v4a3 3 0 0 0 3 3h1"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
            />
            <path
              d="M8 21h8"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
            />
          </svg>
        </span>
        <span class="item-text">Painel de suporte</span>
      </a>
    </div>
  </nav>

  <footer class="sidebar-foot">
    <span *ngIf="!collapsed">{{ appVersion }}</span>
    <span *ngIf="collapsed">{{ appVersion }}</span>
  </footer>
</aside>
